import { NextPrev } from "app/components/basic/Link";
import { ILinkItem } from "app/utils/interfaces";
import { lowercaseAndHyphen } from "app/utils/strings";
import "./NextPrevGroup.scss";

interface IProps {
	currentLinkIndex: number;
	links: ILinkItem[];
	previousButtonLabel?: string;
	nextButtonLabel?: string;
	language: string;
}

const renderNextLink = (props: IProps): JSX.Element => {
	if (props.currentLinkIndex === props.links.length - 1) {
		return <div />;
	}
	const nextLink = props.links[props.currentLinkIndex + 1];
	return (
		<NextPrev
			id={lowercaseAndHyphen(nextLink.name)}
			name={nextLink.name}
			href={nextLink.path}
			direction="next"
			nextButtonLabel={props.nextButtonLabel}
			previousButtonLabel={props.previousButtonLabel}
			language={props.language}
		/>
	);
};

const renderPrevLink = (props: IProps): JSX.Element => {
	if (props.currentLinkIndex === 0) {
		return <div />;
	}
	const prevLink = props.links[props.currentLinkIndex - 1];
	return (
		<NextPrev
			id={lowercaseAndHyphen(prevLink.name)}
			name={prevLink.name}
			href={prevLink.path}
			direction="previous"
			nextButtonLabel={props.nextButtonLabel}
			previousButtonLabel={props.previousButtonLabel}
			language={props.language}
		/>
	);
};

const NextPrevGroup = (props: IProps): JSX.Element => (
	<div className="next-prev-group">
		{renderPrevLink(props)}
		{renderNextLink(props)}
	</div>
);

export default NextPrevGroup;
